/* import __COLOCATED_TEMPLATE__ from './stage-item.hbs'; */
import Component from '@glimmer/component';
import { getCapacitorPackage } from '../../utils/materials';
import type CircuitValues from '../../models/results/sub-results/circuit-details';

interface StageItemArgs {
  details: StageItemDetails;
  geometry: { [key in 'xTranslate' | 'yTranslate' | 'width' | 'height']: number };
  circuitValues: CircuitValues;
}

type StageItemDetails = {
  stageLetter: string;
  stageOrder: number;
  stageFilterType: string;
  stageImplementation: string;
};

type ComponentItem = {
  name: string;
  value: number | null;
  tolerance: number | null;
  minimum: number | null;
  maximum: number | null;
};

export default class StageItem extends Component<StageItemArgs> {
  get xTranslate(): number {
    return this.args.geometry.xTranslate;
  }
  get yTranslate(): number {
    return this.args.geometry.yTranslate;
  }
  get c1Item(): ComponentItem {
    const item = Object.assign({}, this.args.circuitValues.c1);
    const packageType = getCapacitorPackage(item.value, item.tolerance, false);
    const isFirstOrderLowPass =
      this.args.details.stageFilterType === 'low-pass' &&
      this.args.details.stageOrder === 1 &&
      this.args.details.stageImplementation === 'implementation.first-order';
    if (packageType === '0603') {
      item.name = isFirstOrderLowPass ? 'c2' : 'c1';
    } else if (packageType === '1206') {
      item.name = isFirstOrderLowPass ? 'c6' : 'c5';
    }
    return item;
  }
  get c2Item(): ComponentItem {
    const item = Object.assign({}, this.args.circuitValues.c2);
    const packageType = getCapacitorPackage(item.value, item.tolerance, false);
    if (packageType === '0603') {
      item.name = 'c2';
    } else if (packageType === '1206') {
      item.name = 'c6';
    }
    return item;
  }
  get c5Item(): ComponentItem {
    const item = Object.assign({}, this.args.circuitValues.c5);
    const packageType = getCapacitorPackage(item.value, item.tolerance, false);
    if (packageType === '0603') {
      item.name = 'c3';
    } else if (packageType === '1206') {
      item.name = 'c7';
    }
    return item;
  }
  get r1Item(): ComponentItem {
    const item = Object.assign({}, this.args.circuitValues.r1);
    item.name = 'r2';
    return item;
  }
}
